var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"passage-cannot-render-tokens-alert",attrs:{"role":"alert"}},[_vm._v("\n  Due to the number of words in this passage, some features have been disabled\n")])}
var staticRenderFns = []

export { render, staticRenderFns }